module.exports = __webpack_public_path__ + "assets/be6ba974c480b39367656ed4cade80dd.png";